import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Handles the PWA start_url `/rgv-feedback/` — the installed app opens here
 * with no token in the URL. We restore the last-used token from localStorage
 * and redirect. If nothing stored, show a friendly message.
 */
export default function FeedbackAppRedirect() {
  const navigate = useNavigate();
  useEffect(() => {
    let token = null;
    try { token = localStorage.getItem('rgv_fb_last_token'); } catch (e) { /* noop */ }
    if (token) navigate(`/rgv-feedback/${token}`, { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-[#0F1420] text-white flex items-center justify-center p-6" data-testid="feedback-redirect">
      <div className="max-w-sm text-center">
        <p className="text-lg font-semibold mb-2">RGV Feedback</p>
        <p className="text-sm text-white/60">
          This app opens from a personal link generated by the Host. Ask them to WhatsApp your link again to install and start using.
        </p>
      </div>
    </div>
  );
}
